<select [(ngModel)]="modeValue" *ngIf="canPickMode">
  <option [value]="estimationType.storyPoints">{{modeName[estimationType.storyPoints]}}</option>
  <option [value]="estimationType.hours">{{modeName[estimationType.hours]}}</option>
</select>
<span *ngIf="!(canPickMode)">{{modeName[modeValue]}}</span>
